var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.dialog, "max-width": "500", persistent: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.confirm.apply(null, arguments)
                },
              },
            },
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v("Anular recibos"),
                ]),
              ]),
              _c(
                "v-card-text",
                [
                  _c("p", { staticClass: "mb-5" }, [
                    _vm._v(" Se anulan "),
                    _c("b", [_vm._v(_vm._s(_vm.voidable.length))]),
                    _vm._v(
                      " recibos con el mismo motivo. Quedan en el historial, no se borran. Para cargar un reemplazo, anule el recibo desde su fila. "
                    ),
                  ]),
                  _c("v-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:1000",
                        expression: "'required|max:1000'",
                      },
                    ],
                    attrs: {
                      label: "Motivo*",
                      name: "reason",
                      "data-vv-as": "motivo",
                      rows: "3",
                    },
                    model: {
                      value: _vm.reason,
                      callback: function ($$v) {
                        _vm.reason = $$v
                      },
                      expression: "reason",
                    },
                  }),
                  _c("span", { staticClass: "red--text" }, [
                    _vm._v(_vm._s(_vm.errors.first("reason"))),
                  ]),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        text: "",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        text: "",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: _vm.voidable.length == 0,
                      },
                    },
                    [_vm._v("Anular")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }